import axios from '../../../axios/index.js'

export default {
  init () {
    // Refresh-token endpoint not implemented; 401 handling is done in src/axios.js interceptor.
  },
  login (email, pwd) {
    return axios.post('/auth/signin', {
      email,
      password: pwd
    })
  },
  registerUser (name, email, pwd) {
    return axios.post('/auth/signup', {
      username: name,
      email,
      password: pwd
    })
  }
}
